import angular from 'angular';
import ImpersonationService from './impersonation.service';

let impersonationModule = angular.module('impersonation', []).service('impersonationService', ImpersonationService);

export default impersonationModule;



// WEBPACK FOOTER //
// ./app/common/impersonation/impersonation.js